import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../../../../theme/AppTheme";
import { Box } from "@mui/material";
import InvoiceGrid from "./InvoiceGrid/InvoiceGrid";

export default function Invoice (props: { disableCustomTheme?: boolean }) {
    return (
        <AppTheme {...props} >
            <CssBaseline enableColorScheme />
            <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" }, mx: "auto" }}>
                {/* <Paper sx={{ mb: 3 }}>
                    <Formik initialValues={{}} onSubmit={() => { }}>
                        {() => (
                            <Form>
                                <GenericFilter />
                            </Form>
                        )}
                    </Formik>
                </Paper> */}
                <InvoiceGrid />
            </Box>
        </AppTheme>
    )
}